// Pick the lift, then raise the SAFed test job (Session BDC). Used by the "Raise work" entry points that do not already know the lift
// (the Scheduling page's Raise..., and the site and customer pages' Raise work menu). The lift is SEARCHED on the register (Session SC2A: a
// typeahead, never the whole register), narrowed to a customer or site when the host knows one, and a retired item is never offered.
// The raising itself is SafedRaiseForm: one form, one rule.
import { useState } from "react";
import { RecordPicker } from "../../../../components/RecordPicker";
import { SafedRaiseForm } from "./SafedRaiseForm";

export function SafedRaisePicker({
  assetId: presetAssetId,
  customerId,
  siteId,
  onRaised,
  onCancel,
}: {
  assetId?: string | null;
  customerId?: string | null;
  siteId?: string | null;
  onRaised: (jobId: string | null) => void;
  onCancel: () => void;
}) {
  const [assetId, setAssetId] = useState(presetAssetId ?? "");

  return (
    <div>
      <div className="mb-3">
        <RecordPicker
          kind="lift"
          label="Which lift?"
          value={assetId}
          placeholder="Search by ELE number, site or serial"
          selectedLabel={presetAssetId && assetId === presetAssetId ? "This lift" : undefined}
          filters={{ class: "lift", includeRetired: false, ...(siteId ? { siteId } : {}), ...(customerId ? { customerId } : {}) }}
          onChange={(id) => setAssetId(id)}
        />
      </div>
      {assetId ? <SafedRaiseForm key={assetId} assetId={assetId} onRaised={onRaised} onCancel={onCancel} /> : (
        <div className="flex justify-end">
          <button type="button" className="min-h-11 px-3 text-sm text-ele-muted" onClick={onCancel}>Cancel</button>
        </div>
      )}
    </div>
  );
}
